// auth-token.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  private readonly apiUrl = environment.production
    ? 'https://slicksell.click'
    : 'https://stage.slicksell.click';

  constructor(private http: HttpClient) {}

  // Agora recebe user_id e email!
  getSocketJwt(user_id: number, email?: string): Promise<string> {
    return this.http.post<{ token?: string }>(
      `${this.apiUrl}/session-jwt`,
      { user_id, email } // <-- manda no body
    ).toPromise().then(res => {
      if (!res || !res.token) throw new Error('Token JWT não retornado!');
      return res.token;
    });
  }
}
